import {
  ApiRequest,
  Benutzer,
  Benutzerprofil,
  Besichtigung,
  Mandant,
  PaginierteListe,
  Vorgang,
  VorgangRechnungspositionEintrag,
  SucheGutachtenResponse,
  SuchePersonenResponse,
  SucheUnternehmenResponse,
  SucheVorgangResponse,
  ZahlungseingangHistorie,
  Zahlungsimport
} from '../types';

export const BENUTZERPROFIL = (username: string) => `/benutzerprofil/${username}`;
export const BENUTZERPROFIL_ADRESSE = (username: string) => `/benutzerprofil/${username}/adresse`;

export const BESICHTIGUNG = (id: string) => `/besichtigung/${id}`;

export const SUCHE_VORGANG = '/suche/vorgang';
export const SUCHE_PERSON = '/suche/person';
export const SUCHE_UNTERNEHMEN = '/suche/unternehmen';
export const SUCHE_GUTACHTEN = '/suche/gutachten';

export const VORGANG_PROTOKOLL = (vorgangId: string) => `/protokoll/${vorgangId}`;

export const VORGANG_RECHNUNGSPARAMETER = (vorgangId: string) => `/rechnungsparameter/${vorgangId}`;

export const VORGANG_ANLEGEN = '/vorgang/anlegen';

export const MANDANT = (mandantId: string) => `/mandant/${mandantId}`;

export const ZAHLUNGSEINGANG_IMPORT = '/zahlungseingang/import';
export const ZAHLUNGSEINGANG_HISTORIE = '/zahlungseingang/historie';
export const ZAHLUNGSEINGANG_HISTORIE_LOESCHEN = '/zahlungseingang/historie/loeschen';
export const ZAHLUNGSEINGANG_LOESCHEN = '/zahlungseingang/loeschen';

export const benutzerprofil = {
  get: (username: string): ApiRequest<Benutzer & Benutzerprofil> => {
    return {
      url: protectedPath(BENUTZERPROFIL(username)),
      method: 'GET'
    };
  },
  getAdresse: (username: string): ApiRequest<Pick<Benutzerprofil, 'strasse' | 'plz' | 'ort'>> => {
    return {
      url: protectedPath(BENUTZERPROFIL_ADRESSE(username)),
      method: 'GET'
    };
  },
  patch: (username: string, benutzerprofil: Partial<Benutzer>): ApiRequest<Benutzer & Benutzerprofil> => {
    return {
      url: protectedPath(BENUTZERPROFIL(username)),
      method: 'PATCH',
      body: benutzerprofil
    };
  }
};

export const besichtigung = {
  post: (id: string | undefined, partial: Partial<Besichtigung>): ApiRequest<Besichtigung> => {
    return {
      url: protectedPath(BESICHTIGUNG(id ?? '')),
      method: 'POST',
      body: partial
    };
  },
  delete: (id: string): ApiRequest<Besichtigung> => {
    return {
      url: protectedPath(BESICHTIGUNG(id ?? '')),
      method: 'DELETE'
    };
  }
};

export const suche = {
  vorgaenge: (query?: Record<string, any>): ApiRequest<SucheVorgangResponse> => {
    const params = new URLSearchParams(query);
    return {
      url: protectedPath(`${SUCHE_VORGANG}?${params.toString()}`),
      method: 'GET'
    };
  },
  personen: (query?: Record<string, any>): ApiRequest<SuchePersonenResponse> => {
    const params = new URLSearchParams(query);
    return {
      url: protectedPath(`${SUCHE_PERSON}?${params.toString()}`),
      method: 'GET'
    };
  },
  unternehmen: (query?: Record<string, any>): ApiRequest<SucheUnternehmenResponse> => {
    const params = new URLSearchParams(query);
    return {
      url: protectedPath(`${SUCHE_UNTERNEHMEN}?${params.toString()}`),
      method: 'GET'
    };
  },
  gutachten: (query?: Record<string, any>): ApiRequest<SucheGutachtenResponse> => {
    const params = new URLSearchParams(query);
    return {
      url: protectedPath(`${SUCHE_GUTACHTEN}?${params.toString()}`),
      method: 'GET'
    };
  }
};

export const zahlungseingang = {
  importPostUrl: (body: string): ApiRequest<Zahlungsimport> => {
    return {
      url: protectedPath(ZAHLUNGSEINGANG_IMPORT),
      method: 'POST',
      headers: {
        'content-type': 'text/csv'
      },
      body
    };
  },
  getUrl: (jahr: number, nextToken?: string | null): ApiRequest<PaginierteListe<ZahlungseingangHistorie>> => {
    return {
      url: protectedPath(`${ZAHLUNGSEINGANG_HISTORIE}?jahr=${jahr}&nextToken=${nextToken ?? ''}`),
      method: 'GET'
    };
  },
  historieLoeschenPostUrl: (jahr: string, importDatum: string): ApiRequest<PaginierteListe<ZahlungseingangHistorie>> => {
    return {
      url: protectedPath(ZAHLUNGSEINGANG_HISTORIE_LOESCHEN),
      method: 'POST',
      body: {
        jahr,
        importDatum
      }
    };
  },
  loeschePostUrl: (id: string, jahr: string, importDatum: string): ApiRequest<PaginierteListe<ZahlungseingangHistorie>> => {
    return {
      url: protectedPath(ZAHLUNGSEINGANG_LOESCHEN),
      method: 'POST',
      body: {
        id,
        jahr,
        importDatum
      }
    };
  }
};

export const vorgang = {
  legeVorgangAn: (mandant: string): ApiRequest<Vorgang> => {
    return {
      url: protectedPath(VORGANG_ANLEGEN),
      method: 'POST',
      body: {
        mandant
      }
    };
  }
};

export const events = {
  get: (vorgangId: string, nextToken?: string | null): ApiRequest<PaginierteListe<Event>> => {
    const queryParams = nextToken ? '?nextToken=' + nextToken : '';
    return {
      url: protectedPath(VORGANG_PROTOKOLL(vorgangId)) + queryParams,
      method: 'GET'
    };
  }
};

export const mandantOperations = {
  get: (mandantId: string): ApiRequest<Mandant> => {
    return {
      url: protectedPath(MANDANT(mandantId)),
      method: 'GET'
    };
  },
  post: (mandantId: string | undefined, body: Partial<Mandant>): ApiRequest<Mandant> => {
    return {
      url: protectedPath(MANDANT(mandantId ?? '')),
      method: 'POST',
      body
    };
  }
};

export const rechnungsparameterOperations = {
  get: (vorgangId: string): ApiRequest<VorgangRechnungspositionEintrag[]> => {
    return {
      url: protectedPath(VORGANG_RECHNUNGSPARAMETER(vorgangId)),
      method: 'GET'
    };
  }
};

function protectedPath(path: string) {
  return `protected${path}`;
}
